import React from 'react';
import { Link } from 'gatsby';

import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import Classes from './index.module.css';
import hearts from '../assets/images/RamadanHearts.jpg';

const Current = () => (
  <Layout>
    <Sidebar showTabs="false" />
    <div className="container-fluid p-0">
      <section
        className="resume-section p-3 p-lg-5 d-flex justify-content-center"
        id="hearts"
      >
        <div className="w-100">
          <h2 style={{ textAlign: 'center' }}>PATH 1: Awakening</h2>
          <h2 className="mb-3" style={{ textAlign: 'center' }}>Purifying our Hearts اصلاح القلوب</h2>
          
          <p style={{ fontSize: '18px', color: '#BD5D38', marginTop: '2rem', marginBottom: '2rem' }}>
            Before we can build spiritual states, we must first purify our hearts from diseases. 
            This path focuses on awakening from heedlessness and cleansing the heart.
          </p>

          <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
            <h4>Follow the Series:</h4>
            <ul style={{ fontSize: '18px' }}>
              <li>
                <a href="https://www.youtube.com/@myislamnet" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i> YouTube Channel
                </a>
              </li>
              <li>
                <a href="https://medium.com/@myjourneyinlife" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-medium"></i> Medium Articles
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/playlist?list=PLNT8BTFvQYHKJMa-hKZvNDe0xgknoHwdY" target="_blank">
                  YouTube PlayList - Purifying our Hearts
                </a>
              </li>
            </ul>
          </div>

          <h3>The Journey of Awakening</h3>
          
          <h4 style={{ marginTop: '2rem' }}>Step 1: Awakening from Heedlessness</h4>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <Link to="/heedlessness/">Understanding Heedlessness (الغفلة)</Link>
            </li>
          </ul>

          <h4 style={{ marginTop: '2rem' }}>Step 2: Recognizing Heart Diseases</h4>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <Link to="/hypocrite/">Hypocrisy (النفاق)</Link>
            </li>
          </ul>

          <h4 style={{ marginTop: '2rem' }}>Step 3: Purification Series (Based on Amr Khalid)</h4>
          <div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem' }}>
            <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
              <strong>Allah said in the Quran:</strong> "On the Day in which no wealth or children will benefit a person except for the one who comes with a pure heart" 
              <br/>"يوم لا ينفع مال ولا بنون الا من اتى الله بقلب سليم" (سورة الشعراء 88-89)
            </p>
            <p style={{ fontSize: '16px', lineHeight: '1.8', marginTop: '1rem' }}>
              <strong>The Prophet ﷺ said:</strong> "Beware, in the body there is a piece of flesh; if it is healthy, the whole body is healthy and if it is corrupted the whole body is corrupted, and that is the heart." (Bukhari and Muslim)
              <br/>"ألا وَإنَّ في الجَسَدِ مُضْغَةً إذَا صَلَحَتْ صَلَحَ الجَسَدُ كُلُّهُ، وَإِذَا فَسَدَتْ فَسَدَ الجَسَدُ كُلُّهُ ألاَ وَهِيَ القَلْبُ"
            </p>
          </div>

          <ol style={{ fontSize: '18px', lineHeight: '2' }}>
            <li>
              <a href="https://youtu.be/uanY_tvGg58" target="_blank">Introduction (YouTube Video)</a>
            </li>
            <li>
              <a href="https://www.youtube.com/playlist?list=PLNT8BTFvQYHLmHSeXABFEYS-hZ9IwGdWI" target="_blank">
                Best Medication - Ramadan (YouTube Video)
              </a>
              <ul>
                <li>
                  <a href="https://iloveallah.net/static/RamadanAndOurHearts.pdf" target="_blank">Written PDF to download</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="https://youtu.be/rgUxIZCvdX4" target="_blank">First Medication (YouTube Video)</a>
            </li>
            <li>
              <a href="https://youtu.be/5yKvZ_WkKoM" target="_blank">Prepare for Ramadan - Introduction (YouTube Video)</a>
            </li>
            <li>
              <a href="https://youtu.be/UIguNrGpzpg" target="_blank">Second Medication (YouTube Video)</a>
            </li>
            <li>
              <a href="https://youtu.be/EWAr1-F4BzQ" target="_blank">First Sickness - Lower The Gaze (YouTube Video)</a>
            </li>
          </ol>

          <h4 style={{ marginTop: '2rem' }}>Step 4: Protection After Purification</h4>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <Link to="/satan-blocker/">Satan Blocker - Shield Your Heart</Link>
            </li>
            <li>
              <Link to="/satan-steps/">Understanding Satan's Steps</Link>
            </li>
          </ul>

          <h4 style={{ marginTop: '2rem' }}>Essential Practices</h4>
          <ul style={{ fontSize: '18px' }}>
            <li>
              <Link to="/duaa/">Duaa & Supplication الدعاء</Link>
            </li>
            <li>
              <Link to="/sins/">Repentance التوبة</Link>
            </li>
          </ul>

          <div style={{ marginTop: '3rem', padding: '1.5rem', backgroundColor: '#e7f3ff', borderRadius: '8px' }}>
            <h4>Ready for the Next Step?</h4>
            <p style={{ fontSize: '18px' }}>Once you have purified your heart, continue to:</p>
            <Link 
              to="/madarij/" 
              style={{ 
                display: 'inline-block',
                padding: '0.75rem 1.5rem',
                backgroundColor: '#17a2b8',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}
            >
              PATH 2: The Journey (Madarij Assalekeen) →
            </Link>
          </div>

          <h4 style={{ marginTop: '3rem' }}>Audio References (Amr Khalid Series):</h4>
          <ul>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_intro.mp3" target="_blank">
                [Arabic - MP3] Introduction - اصلاح القلوب عمرو خالد
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_ekhlas.mp3" target="_blank">
                [Arabic - MP3] Sincerity (Ikhlas) - الإخلاص
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_tawbah.mp3" target="_blank">
                [Arabic - MP3] Repentance (Tawbah) - التوبة
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_tawakol.mp3" target="_blank">
                [Arabic - MP3] Reliance on Allah (Tawakkul) - التوكل
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_taqua.mp3" target="_blank">
                [Arabic - MP3] God-Consciousness (Taqwa) - التقوى
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_infaq.mp3" target="_blank">
                [Arabic - MP3] Charity (Infaq) - الإنفاق
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_jannah.mp3" target="_blank">
                [Arabic - MP3] Paradise (Jannah) - الجنة
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_mawt.mp3" target="_blank">
                [Arabic - MP3] Death (Mawt) - الموت
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_islam.mp3" target="_blank">
                [Arabic - MP3] Islam - الإسلام
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_reda.mp3" target="_blank">
                [Arabic - MP3] Contentment (Reda) - الرضا
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_yaqeen.mp3" target="_blank">
                [Arabic - MP3] Certainty (Yaqeen) - اليقين
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_3efah.mp3" target="_blank">
                [Arabic - MP3] Chastity (3efah) - العفة
              </a>
            </li>
            <li>
              <a href="https://iloveallah.net/static/hearts_amr_qiamah.mp3" target="_blank">
                [Arabic - MP3] Day of Judgment (Qiamah) - القيامة
              </a>
            </li>
          </ul>
          <img
            className="img-fluid img-profile mx-auto mb-2"
            src={hearts}
            alt="PSM"
          />
        </div>
      </section>
    </div>
  </Layout>
);

export default Current;
